import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import ErrorPage from './components/Error';
import Home from './components/Home'
import Login from './components/Login';
import SignUp from './components/SignUp';
import Search from './components/Search';
import ReportsStorage from './components/ReportsStorage';
import PDFrender from './components/PDFrender';
import Confirm from './components/Confirm';
import ForgetPass from './components/ForgetPass';
import ResetPass from './components/ResetPass';
import About from './components/About';
import ScheduledTasks from './components/ScheduledTasks';


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      { 
        index: true, 
        element: <Home /> 
      },
      {
        path: "/about",
        element: <About />
      },
      {
        path: "/search",
        element: <Search />
      },
      {
        path: "/login",
        element: <Login />
      },
      {
        path: "/signup",
        element: <SignUp />
      },
      {
        path: "/forget-password",
        element: <ForgetPass />
      },
      {
        path: "/reset-password/:token",
        element: <ResetPass />
      },
      {
        path: "/reports-storage",
        element: <ReportsStorage />
      },
      {
        path: "/scheduled-tasks",
        element: <ScheduledTasks />
      },
      {
        path: "/pdf",
        element: <PDFrender />
      },
      {
        path: "/confirm-account/:token",
        element: <Confirm />
      }
    ]
  },
])


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


